/*
 * @Author: yanyongchao
 * @Date: 2018-12-24 20:11:32
 * @Last Modified by: yanyongchao
 * @Last Modified time: 2018-12-24 23:05:08
 */
import moment from 'moment'
import { formatDate, transitionTimestamp, transitionDate, transitDate } from 'untils/formatting'
import Validation from '../untils/validation'
const digitsRE = /(\d{3})(?=\d)/g
export default {
  /**
   * 打印机状态
   * @param val
   * @returns {string}
   */
  printerStatus: val => val === 1 ? '已开启' : '已关闭',

  /**
   * 打印机类型
   * @param val
   * @returns {string}
   */
  printerType: val => val === 1 ? '厨房打印机' : '小票打印机',

  /**
   * 接口类型
   * @param val
   * @returns {string}
   */
  printerInterfaceType: val => val === 1 ? '网口' : 'USB',

  /**
   * 货币格式化
   * @param  {float} value 待转换值
   * @param  {string} currency 货币符号
   * @param  {int} decimals 小数
   * @return {string} 已转换值
   */
  currency: (value, currency, decimals) => {
    value = parseFloat(value)
    if (!isFinite(value) || (!value && value !== 0)) return ''
    currency = currency != null ? currency : '$'
    decimals = decimals != null ? decimals : 2
    var stringified = Math.abs(value).toFixed(decimals)
    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
    var i = _int.length % 3
    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
    var _float = decimals ? stringified.slice(-1 - decimals) : ''
    var sign = value < 0 ? '-' : ''
    return (
      sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float
    )
  },
  /**
   * @function 余额明细类型
   * @param val
   * 1-充值;2-扣减配送费;3-退还配送费;4-取消配送扣减手续费，5-订单取消退款,6-订单有责取消扣款,7-退还配送费失败
   * @returns {*}
   */

  deliveryBalanceType: (val) => {
    let obj = {
      1: '充值',
      2: '支出',
      3: '退款',
      4: '支出',
      7: '退款失败'
    }
    return obj[+val]
  },
  teachTrainPayType: (val) => {
    let obj = {
      1: '微信支付',
      2: '支付宝'
    }
    return obj[+val]
  },
  teachTrainPayTypeLogo: (val) => {
    let obj = {
      1: require('@/assets/images/receiptManager/wx_pay_icon.png'),
      2: require('@/assets/images/receiptManager/ali_pay_icon.png')
    }
    return obj[+val]
  },
  /**
   * @function 教培订单详情状态
   * @param {*} val
   */
  teachTrainTradStatus: (val) => {
    let obj = {
      1: '收款成功',
      2: '收款成功（全额退款）',
      3: '收款成功（部分退款）'
    }
    return obj[+val]
  },
  /**
   * @function 教培收款单状态
   * @param {*} val
   * @returns
   */
  teachTrainReceiptStatus: (val) => {
    let obj = {
      1: '未收款',
      2: '收款中',
      3: '已关闭',
      4: '收款超时',
      5: '收款完成'
    }
    return obj[+val]
  },
  /**
   * @function 服务商
   * @param val
   * @returns {*}
   */
  deliveryServiceProviderList: (val) => {
    let obj = {
      1: '蜂鸟跑腿',
      2: '顺丰配送'
    }
    return obj[+val]
  },
  /**
   * @function 余额明细变更类型
   * @param val
   * @returns {*}
   */
  deliveryChangeType: (val) => {
    let obj = {
      1: '+',
      2: '-'
    }
    return obj[+val]
  },
  /**
   * @function 金额转换
   * @author hutao
   * @param {*}
   **/
  moneyFixed: (val) => {
    return val ? val.toFixed(2) : val
  },
  /**
   * @function 手机号脱敏
   * @param {*} val 脱敏的字段
   * @param {*} headSplit 前3位
   * @param {*} endSplit 后4位
   * @returns val
   */
  desensitization: (val, headSplit = 3, endSplit = 4) => {
    val += ''
    if (val.length < headSplit + endSplit - 1) {
      return val
    } else {
      return val.slice(0, headSplit) + val.slice(headSplit, -endSplit).replace(/\S/g, '*') + val.slice(-endSplit)
    }
  },
  /**
   * @function 检测拼接字符串中是否有手机号码并脱敏
   * @param {*} val
   */
  formValueDes: (val, headSplit = 3, endSplit = 4) => {
    let fromArray = val.split(',')
    for (let i = 0; i < fromArray.length; i++) {
      if (Validation.isTel(fromArray[i])) {
        let val = fromArray[i]
        fromArray[i] = val.slice(0, headSplit) + val.slice(headSplit, -endSplit).replace(/\S/g, '*') + val.slice(-endSplit)
      }
    }
    return fromArray.join(',')
  },
  firstLetterHide: (val) => {
    return val ? ('*' + (val + '').slice(1)) : val
  },
  /**
   * @function 日期格式为月日
   */
  formatDateMonthDay: (date) => {
    const today = moment().startOf('day')
    const inputDate = moment(date).startOf('day')
    const diffDays = inputDate.diff(today, 'days')
    switch (diffDays) {
      case 0: return '今天'
      default: return inputDate.format('MM/DD')
    }
  },
  /**
   * @function 时间戳格式为时分秒
   */
  formatTimestampHms: (val) => {
    let timestamp = val
    if (String(val).length === 10) {
      timestamp = Number(val * 1000)
    }
    return moment(timestamp).format('HH:mm:ss')
  },
  /**
   * @function 时间戳格式为日期时间
   */
  formatTimestampDate: (timestamp) => {
    return moment.unix(timestamp).format('YYYY-MM-DD HH:mm:ss')
  },
  formatDate,
  transitionTimestamp,
  transitionDate,
  transitDate
}
